// extracted by mini-css-extract-plugin
export var main = "hero-module--main--00589";
export var subtitle = "hero-module--subtitle--9e128";
export var title = "hero-module--title--d2b87";